import { SOURCE_TCAPI } from '@rsos/constants/locationSources';

export const getChatButtonText = ({
  source = '',
  isConversationOngoing = false,
}) => {
  if (isConversationOngoing) {
    return 'End Chat';
  }

  switch (source) {
    case SOURCE_TCAPI:
      return 'Accept Chat';
    default:
      return 'Start Chat';
  }
};
